import type { OnboardingContent } from './types';

export const ADMIN_ONBOARDING: OnboardingContent = {
  role: 'ADMIN',
  roleLabel: 'Quản trị',
  tagline: 'Cấu hình tham số, định mức và phê duyệt điều chỉnh từ KAM.',
  steps: [
    {
      id: 'admin-1-welcome',
      title: 'Chào mừng tới Kế hoạch nhân sự v2',
      body:
        'Vai trò Quản trị chịu trách nhiệm cấu hình hệ thống và phê duyệt các điều chỉnh từ KAM. Hướng dẫn này mất 2 phút.',
      bullets: [
        'Cấu hình định mức · tham số mùa',
        'Phê duyệt điều chỉnh forecast',
        'Import dữ liệu lịch sử',
      ],
    },
    {
      id: 'admin-2-params',
      title: 'Cấu hình tham số vận hành',
      body:
        'Trước khi forecast chạy đúng, cần đặt định mức (đơn / giờ / người) và hệ số mùa, hệ số sự kiện. Vào "Cấu hình" để thiết lập một lần.',
      ctaLabel: 'Mở Cấu hình',
      ctaHref: '/admin/config',
    },
    {
      id: 'admin-3-history',
      title: 'Nhập dữ liệu lịch sử',
      body:
        'Engine forecast cần ít nhất 90 ngày đơn lịch sử để đưa ra số tin cậy. Nếu chưa có, hãy import file Excel/CSV ở "Dữ liệu lịch sử".',
      ctaLabel: 'Import lịch sử',
      ctaHref: '/admin/history-import',
    },
    {
      id: 'admin-4-review',
      title: 'Phê duyệt điều chỉnh từ KAM',
      body:
        'Khi KAM gửi yêu cầu điều chỉnh forecast cho khách hàng của họ, bạn sẽ thấy ở "Phê duyệt". Đọc lý do — Chấp nhận hoặc Từ chối kèm ghi chú.',
      ctaLabel: 'Mở Phê duyệt',
      ctaHref: '/planner/forecast/review',
    },
    {
      id: 'admin-5-help',
      title: 'Tài liệu chi tiết ở Trợ giúp',
      body:
        'Mọi SOP đầy đủ (đăng nhập, audit, cấu hình tham số mùa…) đều ở mục Trợ giúp. Bạn có thể chạy lại hướng dẫn này từ đó.',
      ctaLabel: 'Mở Trợ giúp',
      ctaHref: '/help',
    },
  ],
};
